import React,{useEffect, useState} from 'react'
import {useLocation} from 'react-router-dom'


import ProgressBar from '../../components/progressiveBar'

const DashboardHeader = (props)=>{

    const location = useLocation()
    const {pathname} = location
    const pathName= pathname.split('/')
    const finalPathName = pathName[2]

    const [currentUser, setCurrentUser] = useState('')

    useEffect(()=>{
        var retrievedObject = localStorage.getItem('currentUser')
        setCurrentUser(JSON.parse(retrievedObject))
    },[])

    return (
        <div className="dashboard-header-container">
            <div>
                <p>Welcome </p> <b>{currentUser?.given_name} {currentUser?.family_name}, </b>
            </div>
           <div className="mb-4">
            <span>
                Apply for <span style={{
                    color: '#0C8444'
                }}>
                    {/* {finalPathName === 'company'? 
                'Firm membership' : 
                'Individual membership'} */}
                {props.application?.applicantType?.name}

            </span> by following the steps
            </span>
           </div>
           <ProgressBar
                activeStep={props.activeStep}
                />
        </div>
    )
}

export default DashboardHeader